import { IconProps } from "./types";

export default function IcoPoliceVehicle({ color = "#1D1D1D", size = "24" }: IconProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.9783 15.0274C8.53155 15.0274 8.98004 14.5822 8.98004 14.033C8.98004 13.4839 8.53155 13.0387 7.9783 13.0387C7.42506 13.0387 6.97656 13.4839 6.97656 14.033C6.97656 14.5822 7.42506 15.0274 7.9783 15.0274Z"
				fill={color}
			/>
			<path
				d="M15.9939 15.0274C16.5472 15.0274 16.9957 14.5822 16.9957 14.033C16.9957 13.4839 16.5472 13.0387 15.9939 13.0387C15.4407 13.0387 14.9922 13.4839 14.9922 14.033C14.9922 14.5822 15.4407 15.0274 15.9939 15.0274Z"
				fill={color}
			/>
			<path
				d="M4 11.0973H20M6.99994 18.0108V19.9994M17 18.0108V19.9994M13.821 6.07878H16.8934L18.9971 11.0973V18.0108H4.97272V11.0973L7.07637 6.07878H10.6076M13.821 6.07878V5.58195C13.821 4.70826 13.1016 4 12.2143 4C11.3269 4 10.6076 4.70826 10.6076 5.58195V6.07878M13.821 6.07878H10.6076"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
